import { StorageService } from "../../services";
import { apiService } from "../../services/apiService";
import { utilService } from "../../services/utilService";
import { apiServiceConstants, CONSTANTS } from "../../constants";

import {
  LoginParams,
  NetworkResult,
  RespNetworkResult,
  RespLoginUserModel,
  loggedInResultInterface,
} from "./login.model";

import { Device } from "@ionic-native/device";

const login = async (params: LoginParams): Promise<loggedInResultInterface> => {
  const respApiResult = await apiService
    .apiCall(
      "auth/login/?reg_code=" + params.network,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
   .then((res) => {
  const userResp = res as RespLoginUserModel;

  // ✅ Check if result exists
  if (userResp?.result && userResp.result.length > 0) {
    const logginedUser = setLoggedInUserModel(userResp);

    return {
      isSuccess: true,
      loggedInUser: logginedUser,
      status: userResp.status,
      message: userResp.message,
    };
  } else {
    // ❗ API returned success=false or empty user
    return {
      isSuccess: false,
      message: userResp?.message || "Login failed",
      status: userResp?.status,
    };
  }
})
    .catch((err) => {
      const result: loggedInResultInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const checkNetwork = async (params: object): Promise<NetworkResult> => {
  const respApiResult = await apiService
    .apiCall(
      "user/network-code-check/",
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as RespNetworkResult;
      const result: NetworkResult = {
        isSuccess: true,
        isValidNetwork: response.result?.[0]?.network_exist,
        status: response.status,
        message: response.message,
      };
      return result;
    })
    .catch((err) => {
      const result: NetworkResult = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const getParamsForNewSubscription = (
  pltfrm: any,
  token: any,
  deviceId = "",
  name = ""
) => {
  return {
    name: Device.model,
    guid: "5D94-6A66-44E5-9007",
    type: pltfrm,
    registration_id: token,
    device: Device.uuid,
  };
};

const setNotification = async (tok: any) => {
  // Debug leftovers removed: this logged the push token and then showed the
  // whole subscription payload in a native alert().
  return getParamsForNewSubscription("android", tok);
};

////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////// FUNCTIONS FOR GETTING VALUES STARTS /////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////

const getLoginParams = (params: LoginParams) => {
  return {
    username: params.username,
    password: params.password,
    network: params.network,
  };
};

////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////// FUNCTIONS FOR GETTING VALUES ENDS ///////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////// FUNCTIONS FOR SETTING VALUES STARTS /////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////

const setLoggedInUserModel = (payload: RespLoginUserModel) => {
  if (!payload?.result || payload.result.length === 0) {
    return null; // 👈 prevent crash
  }

  const user = payload.result?.[0];

  return {
    guid: user.guid,
    id: user.id,
    role: user.role,
    color: user.color,
    email: user.email,
    group: user.group,
    token: user.token,
    firstName: user.first_name,
    lastName: user.last_name,
    profilePic: user.profile_pic,
    displayName: user.display_name,
    rolePermissions: user.role_based_permission,
    unavailableWhenNotoncall: user.unavailable_when_not_oncall,
    n2nActivationStatus: user?.n2n_user_listing,
    n2nPermission: user?.n2n_activation,
    sipUsername: user?.sip_username
  };
};

const setRolePermissionModel = (payload: any) => {
  const rolePermissions = {
    addAdditionalColumn: payload.add_additional_column,
    addCareTeam: payload.add_care_team,
    addSupportStaff: payload.add_support_staff,
    admitPatient: payload.admit_patient,
    coverageTab: payload.coverage_tab,
    editCareTeam: payload.edit_care_team,
    editSupportStaff: payload.edit_support_staff,
    mediaShare: payload.media_share,
    messagePermission: payload.message_permission,
    myPatients: payload.my_patients,
    mySchedule_card: payload.my_schedule_card,
    newCustomColumn: payload.new_custom_column,
    notifyCareTeam: payload.notify_care_team,
    nurseManagement: payload.nurse_management,
    onBehalf: payload.on_behalf,
    onCallLookUp: payload.on_call_look_up,
    statusBoard: payload.status_board,
    unassignShift: payload.unassign_shift,
    startACase: payload.start_a_case,
    n2nCommunication:payload?.n2n_communication
  };

  return rolePermissions;
};

const setStorage = (
  id: number,
  passwordStatus: boolean,
  token: string,
  guid: string,
  network: string,
  rolePermissions: object,
  userRoles: {}[],
  isDarkMode: boolean,
  unavilabilityStatus: boolean,
  isN2NActivated:boolean,
  firstName: string,
  lastName: string,
  n2nPermission:boolean,
  sipUsername:any
) => {
  const local_keys = {
    isLoggedIn: true,
    savePassword: passwordStatus,
  };

  const storage_keys = {
    token: token,
    network: network,
    guid: guid,
    userId: id,
    rolePermissions: JSON.stringify(rolePermissions),
    roles: JSON.stringify(userRoles),
    isDarkMode: isDarkMode,
    unavilabilityStatus: unavilabilityStatus,
    isN2NActivated: isN2NActivated,
    firstName: firstName,
    lastName: lastName,
    n2nPermission:n2nPermission,
    sipUsername:sipUsername
  };
  StorageService.setStorageItem(
    CONSTANTS.STORAGE[true === passwordStatus ? 1 : 0],
    storage_keys,
    true
  );
  StorageService.setStorageItem(localStorage, local_keys);
};


const getSipCredentials = async (reqParams: any): Promise<any> => {
  try {
    const url = `user/get-sip-credentials?reg_code=${reqParams.reg_code}`; // ✅ FIX

    const res = await apiService.apiCall(
      url,
      {}, // no body needed for GET
      apiServiceConstants.GET,
      utilService.getDeviceType()
    );

    const response = res as any;

    return {
      isSuccess: response.isSuccess,
      message: response.message,
      result: response.result,
    };
  } catch (err: any) {
    console.error("❌ API failed:", err);

    return {
      responseData: [],
      isSuccess: false,
      message: err?.message ?? "Unknown error",
    };
  }
};


////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////// FUNCTIONS FOR SETTING VALUES ENDS /////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////

const handleErrorResponse = () => {};

export const loginPageService = {
  login,
  setStorage,
  checkNetwork,
  getLoginParams,
  handleErrorResponse,
  setLoggedInUserModel,
  setRolePermissionModel,
  setNotification,
  getSipCredentials
};
